export default function FeaturedService() {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 items-center">
          {/* Text */}
          <div className="order-2 md:order-1">
            <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-4 font-light">
              Featured Treatment / <span style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>علاج مميز</span>
            </p>
            <h2
              className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide mb-2 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Signature{" "}
              <span className="italic text-[#c6a864]">Gold Facial</span>
            </h2>
            <p
              className="text-[#1a2744] text-xl sm:text-2xl font-semibold mb-1"
              style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
            >
              جلسة الوجه الذهبية المميزة
            </p>
            <p
              className="text-[#1a2744]/60 text-sm mb-5 tracking-wide"
              style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
            >
              علاجنا الأكثر طلباً في صالون القمر الأزرق، مسقط
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-3">
              Our signature Gold Facial harnesses 24K gold and premium serums to
              deeply nourish and revitalize your skin. Specifically formulated
              for the Muscat climate, this treatment restores radiance and
              youthfulness in just one session.
            </p>
            <p
              className="text-gray-400 text-sm leading-relaxed mb-3 text-right"
              style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
            >
              جلسة الوجه الذهبية تستخدم الذهب عيار 24 قيراط والمصلات الفاخرة لتغذية بشرتك بعمق وتجديد حيويتها. تم تركيبها خصيصاً لمناخ مسقط لاستعادة الإشراقة والشباب في جلسة واحدة.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Trusted by hundreds of clients across Muscat and Al Koudh, our
              expert aestheticians tailor every session to your unique skin needs.
            </p>
            <p
              className="text-gray-400 text-sm leading-relaxed mb-8 text-right"
              style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
            >
              موثوق به من قِبل مئات العملاء في مسقط والخوض. خبراؤنا يخصصون كل جلسة وفقاً لاحتياجات بشرتك الفريدة.
            </p>

            <div className="grid grid-cols-3 gap-3 mb-8">
              {[
                { icon: "ri-sparkling-2-line", en: "Deep Nourish", ar: "تغذية عميقة" },
                { icon: "ri-sun-line", en: "Glow Boost", ar: "إشراقة البشرة" },
                { icon: "ri-shield-line", en: "Anti-Aging", ar: "مكافحة الشيخوخة" },
              ].map((f) => (
                <div key={f.en} className="text-center border border-[#ece8e0] py-4 px-2">
                  <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                    <i className={`${f.icon} text-[#c6a864] text-xl`}></i>
                  </div>
                  <p className="text-[#1a2744] text-xs font-light uppercase tracking-wide">{f.en}</p>
                  <p className="text-gray-400 text-xs mt-0.5" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{f.ar}</p>
                </div>
              ))}
            </div>

            <a
              href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 whitespace-nowrap cursor-pointer bg-[#c6a864] text-white text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-[#b8965a] transition-colors duration-300"
            >
              <i className="ri-whatsapp-line text-base"></i>
              <span>Book Now</span>
              <span className="opacity-80" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>— احجزي الآن</span>
            </a>
          </div>

          {/* Image */}
          <div className="order-1 md:order-2 relative overflow-hidden h-[380px] sm:h-[480px] md:h-[520px]">
            <img
              src="https://public.readdy.ai/ai/img_res/3678c7e37a9df258ae0716c1327778c2.jpg"
              alt="Signature Gold Facial Treatment - Blue Moon Beauty Salon Muscat Oman"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute top-4 right-4 flex flex-col items-end gap-1">
              <span className="bg-[#c6a864] text-white px-3 py-1.5 text-xs tracking-widest uppercase font-light">Best Seller</span>
              <span className="bg-[#1a2744] text-white px-3 py-1.5 text-xs font-medium" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>الأكثر طلباً</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
